/* eslint-disable no-negated-condition */
/* global */
/* eslint-disable react/prop-types */
import React from 'react';
import css from './MeetingBanner.scss';
import classNames from 'classnames';
import PropTypes from 'prop-types';
import { Button } from 'panamera-react-ui';
import { FormattedMessage as Translation } from 'react-intl';

import { threadMeetingSelector } from 'Selectors/chat';
import _setLoginModalState from 'Actions/setLoginModalState';
import withConfig from 'HOCs/withConfig/withConfig';
import withTrack from 'HOCs/withTrack/withTrack';
import { connect } from 'react-redux';
import withRouter from 'HOCs/withRouter';
import { compose } from 'redux';

import { setB2CMeetingFlowType } from 'Helpers/meetings';
import Auth from '../../../../Auth';
import { MEETING_STATUS, MEETING_TYPE, RESERVED_STATUS } from 'Constants/chat';
import { getMeetingDate } from '../../../Confirmation/utils';
import { isPastDate, formatDate } from 'Helpers/dates';
import { IS_DESKTOP } from 'Constants/device.APP_TARGET';
import { handleMeeting } from 'Helpers/meetingHandler';
import { TrackerOrigins } from 'Components/TrackerProvider/TrackerProvider';
import { MEETING_EVENTS } from 'Constants/tracking';
import withFeatureFlags from 'HOCs/withFeatureFlags/withFeatureFlags';
import { RESERVE } from 'Constants/constants';
import { AD_PAGE } from 'Constants/items';

export const MeetingBanner = props => {
    const {
        track,
        itemId,
        itemUserId,
        threadMeeting,
        router,
        setLoginModalState,
        reservationData,
        showGalleryNavTiles
    } = props;

    const staticAssetUrl = props.config.get('staticAssets');

    const handleReserveDetails = () => {
        const {
            router,
            itemId
        } = props;

        router.push(`/checkout/${itemId}/confirmation?origin=adp&from=${RESERVE.ADP_BANNER}`);
        track(MEETING_EVENTS.VIEW_DETAILS, {
            origin: TrackerOrigins.ITEM_PAGE,
            flow_type: TrackerOrigins.ITEM_PAGE,
            field_name: 'reserve_car',
            posting_variant: 'B2C',
            item_id: itemId,
            seller_id: itemUserId,
            buyer_id: Auth.getUser()?.id,
            select_from: 'reserve'
        });
    };

    const handleTestDriveDetails = () => {
        if (!Auth.isLoggedIn()) {
            setLoginModalState({
                state: true,
                callback: () => {
                    handleTestDriveDetails();
                }
            });
        }
        else if (props.showStoreTestdriveOnAdpv || props.showStoreVisitOnAdpv) {
            setB2CMeetingFlowType(AD_PAGE);
            track(MEETING_EVENTS.VIEW_DETAILS, {
                origin: TrackerOrigins.ITEM_PAGE,
                flow_type: TrackerOrigins.ITEM_PAGE,
                field_name: 'store_test_drive',
                posting_variant: 'B2C',
                item_id: itemId,
                seller_id: itemUserId,
                buyer_id: Auth.getUser()?.id,
                select_from: 'testdrive'
            });
            track('chat_tap_meeting', {
                flow_type: AD_PAGE,
                field_name: 'store_test_drive',
                posting_variant: 'B2C',
                item_id: itemId,
                seller_id: itemUserId,
                buyer_id: Auth.getUser()?.id
            });
            track('tap_view_meeting', {
                flow_type: AD_PAGE,
                field_name: 'store_test_drive',
                posting_variant: 'B2C',
                item_id: itemId,
                seller_id: itemUserId,
                buyer_id: Auth.getUser()?.id,
                num_variants_shown: threadMeeting?.date
            });
            router.push(`/meeting/confirmation/${itemId}`, { state: { fromPage: AD_PAGE }});
        }
    };

    const setMeetingType = () => {
        return threadMeeting?.type === MEETING_TYPE.STORE
            ? 'Store'
            : 'Home';
    };

    const setTDCancelTextDate = () => {
        const meetingType = setMeetingType();

        return {
            translationVars: {
                type: meetingType
            }
        };
    };

    const setTDCompleteTextDate = date => {
        const translationObj = {};
        const meetingType = setMeetingType();

        if (isPastDate(date) || threadMeeting?.meetingStatus === MEETING_STATUS.DONE) {
            translationObj.bannerText = props.showStoreVisitOnAdpv ? 'StoreVisitCompleted' : 'testDriveComplete';
            translationObj.bannerDefaultMsg = props.showStoreVisitOnAdpv ? 'Store visit Completed' : 'Test drive Completed';
            translationObj.translationVars = {
                type: meetingType
            };
        }

        else {
            const { daysLeft } = getMeetingDate(
                date,
                props.config.get('lang')
            );

            switch (daysLeft) {
                case 0 : {
                    translationObj.bannerText = props.showStoreVisitOnAdpv ? 'StoreVisitToday1' : 'testDriveToday1';
                    translationObj.bannerDefaultMsg = props.showStoreVisitOnAdpv ? 'Store visit today!' : 'Test drive today!';
                    translationObj.translationVars = {
                        type: meetingType
                    };
                    break;
                }
                case 1 : {
                    translationObj.bannerText = props.showStoreVisitOnAdpv ? 'StoreVisitTomorrow1' : 'testDriveTomorrow1';
                    translationObj.bannerDefaultMsg = props.showStoreVisitOnAdpv ? 'Store visit tomorrow!' : 'Test drive tomorrow!';
                    translationObj.translationVars = {
                        type: meetingType
                    };
                    break;
                }
                default : {
                    translationObj.translationVars = {
                        type: meetingType,
                        nDays: daysLeft
                    };
                    break;
                }
            }
        }
        return translationObj;
    };

    const setReserveTextDate = reserveData => {
        const expFormatDate = formatDate(new Date(parseInt(reserveData?.expiryDate, 10)), 'YYYY-MM-DD');
        const { daysLeft } = getMeetingDate(
            expFormatDate,
            props.config.get('lang')
        );

        switch (daysLeft) {
            case 0:
                return {
                    bannerText: 'reserveForTodayAdp',
                    bannerDefaultMsg: 'Reserved for today'
                };
            case 1:
                return {
                    bannerText: 'reservedForDayAdp',
                    bannerDefaultMsg: `Reserved for next ${daysLeft} day`,
                    translationVars: {
                        nReserveDays: daysLeft
                    }
                };
            default:
                return {
                    bannerText: 'reservedForDaysAdp',
                    bannerDefaultMsg: `Reserved for next ${daysLeft} days`,
                    translationVars: {
                        nReserveDays: daysLeft
                    }
                };
        }
    };

    const isReserveAvailable = reserveData => {
        const expFormatDate = formatDate(new Date(parseInt(reserveData?.expiryDate, 10)), 'YYYY-MM-DD');

        return ((!isPastDate(expFormatDate))
            && (reserveData?.status == RESERVED_STATUS.RESERVED)
            && reserveData?.isReservedByCurrentUser);
    };

    const setCardType = () => {
        let CARD_TYPE = '';

        if (props.showReserve && isReserveAvailable(reservationData)) {
            CARD_TYPE = 'RESERVE';
        }
        else if (props.showStoreTestdriveOnAdpv && threadMeeting?.meetingStatus === MEETING_STATUS.ACCEPTED) {
            CARD_TYPE = 'TEST_DRIVE_CNF';
        }
        else if (props.showStoreTestdriveOnAdpv && threadMeeting?.meetingStatus === MEETING_STATUS.REJECTED) {
            CARD_TYPE = 'TEST_DRIVE_CNC';
        }
        else if ((props.showStoreVisitOnAdpv) && threadMeeting?.meetingStatus === MEETING_STATUS.ACCEPTED) {
            CARD_TYPE = 'STORE_VISIT_CNF';
        }
        else if ((props.showStoreVisitOnAdpv) && threadMeeting?.meetingStatus === MEETING_STATUS.REJECTED) {
            CARD_TYPE = 'STORE_VISIT_CNC';
        }
        return CARD_TYPE;
    };

    const formatData = () => {
        const CARD_TYPE = setCardType();
        let meetingObj = handleMeeting(CARD_TYPE, handleReserveDetails, handleTestDriveDetails);
        let translationObj = {};

        switch (CARD_TYPE) {
            case 'TEST_DRIVE_CNF' : {
                translationObj = setTDCompleteTextDate(threadMeeting?.date);
                break; }
            case 'TEST_DRIVE_CNC' : {
                translationObj = setTDCancelTextDate();
                break; }
            case 'STORE_VISIT_CNF' : {
                translationObj = setTDCompleteTextDate(threadMeeting?.date);
                break; }
            case 'STORE_VISIT_CNC' : {
                translationObj = setTDCancelTextDate();
                break; }
            case 'RESERVE' : {
                translationObj = setReserveTextDate(reservationData);
                break;
            }
        }

        meetingObj = { ...meetingObj, ...translationObj };

        return {
            meetingObj,
            CARD_TYPE
        };
    };

    const { meetingObj, CARD_TYPE } = formatData();

    if (!CARD_TYPE) {
        return <></>;
    }

    return (
        <div className={ classNames(
            css.detailCardWrapper,
            css[meetingObj.backgroundCss],
            IS_DESKTOP ? css.detailCardWrapperDesktop : css.detailCardWrapperMobile,
            showGalleryNavTiles ? css.mt20 : ''
        ) }
        >
            <div className={ css.detailComponent } >
                <img
                    src={ `${staticAssetUrl}${meetingObj.bannerImg}` }
                    alt={ meetingObj.bannerImgAlt }
                    className={ IS_DESKTOP ? css.imgDesktop : css.imgMobile }
                />
                <div className={ IS_DESKTOP ? css.detailTextDesktop : css.detailTextMobile } >
                    <Translation
                        values={ meetingObj.translationVars }
                        id={ meetingObj.bannerText }
                        defaultMessage={ meetingObj.bannerDefaultMsg }
                    />
                </div>
            </div>
            <div className={ IS_DESKTOP ? css.redirectionComponentDesktop : css.redirectionComponentMobile }>
                <Button
                    onClick={ meetingObj.handler }
                    icon={ null }
                    size="small"
                    className="buttonClass"
                >
                    <span>
                        <Translation
                            id="viewDetails"
                            defaultMessage="View Details" />
                    </span>
                </Button>
            </div>
        </div>
    );
};

MeetingBanner.propTypes = {
    itemUserId: PropTypes.string.isRequired,
    itemId: PropTypes.string,
    setLoginModalState: PropTypes.func,
    router: PropTypes.object,
    threadMeeting: PropTypes.shape({
        meetingStatus: PropTypes.string,
        date: PropTypes.string
    }).isRequired,
    track: PropTypes.func.isRequired,
    showReserve: PropTypes.bool,
    showStoreTestdriveOnAdpv: PropTypes.bool,
    showStoreVisitOnAdpv: PropTypes.bool,
    showGalleryNavTiles: PropTypes.bool
};

MeetingBanner.defaultProps = {
    itemUserId: '',
    itemId: '',
    setLoginModalState: () => {},
    router: {},
    threadMeeting: {},
    track: () => {},
    showReserve: false,
    showStoreTestdriveOnAdpv: false,
    showStoreVisitOnAdpv: false,
    reservationData: {},
    showGalleryNavTiles: false
};

export const mapStateToProps = (state, { itemUserId, itemId }) => {
    return {
        threadMeeting: threadMeetingSelector(state, { userId: itemUserId, itemId })
    };
};

export const mapDispatchToProps = dispatch => ({
    setLoginModalState: state => dispatch(_setLoginModalState(state))
});

export default compose(
    withTrack,
    withConfig,
    withRouter,
    withFeatureFlags,
    connect(mapStateToProps, mapDispatchToProps)
)(MeetingBanner);

